import { render, staticRenderFns } from "./DexLogo.vue?vue&type=template&id=09075efa&scoped=true&"
import script from "./DexLogo.vue?vue&type=script&lang=ts&"
export * from "./DexLogo.vue?vue&type=script&lang=ts&"
import style0 from "./DexLogo.vue?vue&type=style&index=0&id=09075efa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09075efa",
  null
  
)

export default component.exports